import { render, staticRenderFns } from "./PayoutSettings.vue?vue&type=template&id=84e52e40&scoped=true"
import script from "./PayoutSettings.vue?vue&type=script&lang=js"
export * from "./PayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./PayoutSettings.vue?vue&type=style&index=0&id=84e52e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e52e40",
  null
  
)

export default component.exports